import React from "react";
import { Button, Col, Row, Table, Spinner } from "react-bootstrap";
import {
  useFetchProductDetailsQuery,
  useFetchPaymentHistoryQuery,
  useBillingPortalMutation,
} from "store/services/user.service";
import toast from "react-hot-toast";
import Loader from "components/shared/Loader";
import ErrorComponent from "components/shared/ErrorComponent";
import { Link } from "react-router-dom";

const PaymentHistorySec = () => {
  const {
    data: paymentHistory,
    error: paymentError,
    isLoading: paymentLoading,
  } = useFetchPaymentHistoryQuery();

  const {
    data: currentPlan,
    error: planError,
    isLoading: planLoading,
  } = useFetchProductDetailsQuery();

  const [openBillingPortal, { isLoading: billingPortalLoading }] = useBillingPortalMutation();

  const handleEdit = async (id) => {
    try {
      const response = await openBillingPortal(id).unwrap();
      if (!response || !response?.data?.url) {
        throw new Error("Invalid response from cancel subscription");
      }
      window.location.href = response?.data?.url;
    } catch (error) {
      console.error("Error in cancellation:", error);
      toast.error("Failed to cancel the subscription.");
    }
  };

  if (paymentLoading || planLoading) {
    return (
      <Loader />
    );
  }

  if (paymentError || planError) {
    return (
      <ErrorComponent />
    )
  }

  return (
    <>
      <div className="inner">
        <Row>
          <Col lg="12" className="my-2">
            <h2>Active Plan</h2>
            <Table className="commonTable" responsive>
              <thead>
                <tr>
                  <th className="border-0 fw-normal py-3 px-3">Plan Name</th>
                  <th className="border-0 fw-normal py-3 px-3">Start Date</th>
                  <th className="border-0 fw-normal py-3 px-3">End Date</th>
                  <th className="border-0 fw-normal py-3 px-3">Status</th>
                  <th className="border-0 fw-normal py-3 px-3">Action</th>
                </tr>
              </thead>
              <tbody>
                {currentPlan && currentPlan?.plan_status ? (
                  <tr>
                    <td className="border-0 p-3 text-capitalize">
                      {currentPlan?.name}
                    </td>
                    <td className="border-0 p-3">
                      {currentPlan?.current_period_start
                        ? new Date(
                            currentPlan?.current_period_start
                          ).toLocaleDateString()
                        : null}
                    </td>
                    <td className="border-0 p-3">
                      {currentPlan?.current_period_end
                        ? new Date(
                            currentPlan?.current_period_end
                          ).toLocaleDateString()
                        : null}
                    </td>
                    <td className="border-0 p-3 text-capitalize">{currentPlan?.plan_status}</td>
                    <td>
                      <div className="d-flex align-items-center gap-10">
                        {currentPlan?.name ? (
                          <Link
                            onClick={() =>
                              handleEdit(currentPlan?.product?.customer)
                            }
                            className="border-0 p-0 mt-2 themeClr"
                            variant="transparent"
                          >
                            {billingPortalLoading ? "Please wait..." : "Manage"}
                          </Link>
                        ) : null}
                      </div>
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      No active plan available.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row>
          <Col lg="12" className="my-2">
            <h2>Payment History</h2>
            <Table className="commonTable" responsive>
              <thead>
                <tr>
                  <th className="border-0 fw-normal py-3 px-3">Payment Date</th>
                  <th className="border-0 fw-normal py-3 px-3">Amount Paid</th>
                  <th className="border-0 fw-normal py-3 px-3">
                    Payment Status
                  </th>
                </tr>
              </thead>
              <tbody>
                {paymentHistory?.length > 0 ? (
                  paymentHistory.map((payment, key) => (
                    <tr key={key}>
                      <td className="border-0 p-3">
                        {new Date(payment?.start_date).toLocaleDateString()}
                      </td>

                      <td className="border-0 p-3">
                        ${(payment?.amount_paid / 100).toFixed(2)}
                      </td>
                      <td className="border-0 p-3 text-capitalize">
                        {payment?.plan_status}
                      </td>
                      <td className="border-0 p-3 text-capitalize">
                        {payment?.invoice_status}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center">
                      No payment history available.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default PaymentHistorySec;
